import { useEffect } from 'react';
import companyMenuService from './company_menu.service';
import { highlightSubMenuItem } from '../../company/highlightMenuItem';

/**
 * Gets data - claim group, and elster name and id
 */
const customMenuCreatorService = {
  usePrepare: function (comparisonData) {
    let queryParamForServiceCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let companyId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let claimGroupMenuItemsCreator = arguments.length > 3 ? arguments[3] : undefined;
    const {
      companyMenu,
      fetchCompanyMenu
    } = companyMenuService.useCrud(companyId, false);
    useEffect(() => {
      if (!(comparisonData !== null && comparisonData !== void 0 && comparisonData.id) || !window.MARKET_CONSTANTS.SHOULD_CALL_COMPANY_MENU) return;
      fetchCompanyMenu(queryParamForServiceCall);
    }, [comparisonData === null || comparisonData === void 0 ? void 0 : comparisonData.id, fetchCompanyMenu]);
    const customMenuItems = claimGroupMenuItemsCreator({
      company: companyMenu,
      allClaimGroups: companyMenu === null || companyMenu === void 0 ? void 0 : companyMenu.claim_groups
    });
    const customMenuItemsHighlighted = highlightSubMenuItem(customMenuItems, comparisonData);
    return [customMenuItemsHighlighted, fetchCompanyMenu, queryParamForServiceCall];
  }
};
export default customMenuCreatorService;